import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import TenseRow from './TenseRow';

export default function Sentence() {

    const [tenseList, setTenseList] = useState([]);
    const [loading, setLoading] = useState(false);
    const textRef = useRef()

    useEffect(() => {
        setLoading(true)
      axios.get("/sentences/listing")
      .then(response=>{
          if(response?.data){
            let result = response.data;
            setTenseList(result)
            setLoading(false)
            //console.log("response", result)
          }
      })
      .catch(error=> console.log(error))
    }, []);

    const searchTense=()=>{
        setLoading(true)
        let query = textRef.current.value;
        query = query.trim()
        axios.post("/sentences/search", {query:query})
        .then(response=>{
            if(response?.data){
                let result = response.data;
                setTenseList(result)
                setLoading(false)
                //console.log("response", result)
            }
        })
        .catch(error=> console.log(error))
    }

  return <>
        <div className='row'>
            <div className='col-lg-4 col-8 entryHead dateFilter'>
                <input type="text" ref={textRef} className='form-control' onKeyUp={()=>searchTense()} />
            </div>
            <div className='col-lg-2 col-4 entryHead'>
                <button type="button" className="btn btn-warning largeBtn btnCenter" onClick={()=>searchTense()}>Search</button>
            </div>
        </div>
        <div className='row'>
            <div className='col-lg-2 col-4 entryHead'>Sentence</div>
            <div className='col-lg-2 col-4 entryHead'>Meaning</div>
            <div className='col-lg-2 col-4 entryHead'>Detail</div>
        </div>
        {
            (!loading) ?
            tenseList.map((data, key)=>{
                return <TenseRow {...data} key={key}/>
            })
            :
            <Skeleton count={10} />
        }
  </>;
}
